import { req, post, get } from '@/plugins/axios'
import { ElPopconfirm } from 'element-plus'

/**
* 商品添加收藏
* @param {Object} data
*/
export function productFavorite (data: any) {
  return req('/goods/favorite/product/add', data)
}

/**
* 商品取消收藏
* @param {Object} data
*/
export function productFavoriteCancel (data: any) {
  return req('/goods/favorite/product/cancel', data)
}

/**
* 操作商品喜欢和不喜欢
* @param {Object} data
*/
export function handleProductBehavior (data: any) {
  return post('/goods/behavior/product', data)
}

/**
* 推荐商品列表（猜你喜欢的商品）
* @param {Object} data
*/
export function getRecommendGoodsList (data: any) {
  return post('/goods/recommend/product', data)
}

/**
* 市场购-爆款商品列表
* @param {Object} data
*/
export function getPopularGoodsList (data: any) {
  return post('/goods/mall/popular/product/list', data)
}

/**
* 获取收藏的商品列表
* @param {Object} data
*/
export function getFavoriteGoodsList (data: any) {
  return post('/goods/favorite/product/list', data)
}

/**
* 获取看过的商品列表
* @param {Object} data
*/
export function getLookGoodsList (data: any) {
  return post('/goods/footprint/footprint/product', data)
}

/**
* 获取买过的商品列表
* @param {Object} data
*/
export function getBuyGoodsList (data: any) {
  return post('/goods/footprint/bought/product', data)
}

/**
* 获取担当推荐的商品
* @param {Object} data
*/
export function getConfigRecommendGoods (data: any) {
  return post('/goods/footprint/strategy/product', data)
}

/**
* 查询商品次品率
* @param {Object} data
*/
export function searchGoodsDefectiveApi (params: any) {
  return get('/goods/product/spu/defective', { params })
}

/**
* 根据URL获取商品
* @param {Object} data
*/
export function detailByUrl (data: any) {
  return post('/goods/product/detailByUrl', data)
}

// 查询oem商品
export function searchOemGoodsApi (data: any) {
  return post('/order/oem/listSearchSourceOrderSkuDetail', data)
}

// 店铺商品关联
export function shopGoodsBindApi (data: any) {
  return post('/api/thirdShopItem/mappingSku', data)
}

// 亚马逊sku解绑
export function unbindAmazonSkuApi (data: any) {
  return post('/order/shop/product/sku/unbindAmazonSku', data)
}
// 查询库存商品
export function searchStockApi (data: any) {
  return req('/order/shop/product/sku/page', data)
}

// 查询组合商品信息
export function searchCombineProductApi (data: any) {
  return req('/order/combination/product/selectByCombinationProductSku', data)
}

// 商品查询黑名单商品
export function searchGoodsApi (data: any) {
  return post('/goods/product/detail/ignoreBlack', data)
}

// 商品查询黑名单商品
export function searchOemDetail (data: any) {
  return req('/order/searchSourceOrder/show/getRelatedDetail', data)
}

// 计算成本
export function calcGoodsPriceApi (data: any) {
  return post('/settlement/calc/execute', data)
}

// 搜款网营销类目树结构
export function selectLastCategoryTree (data: any) {
  return post('/goods/mall/market/category/selectLastCategoryTree', data)
}

// 供应商店铺分页列表
export function supplierShopPageList (data: any) {
  return post('/goods/supplierShop/pageList', data)
}

// 供应商商品搜索
export function suppliersSearch (data: any) {
  return post('/goods/search/suppliers', data)
}

// 网商园类目
export function supplierShopListMajorCate (data: any) {
  return post('/goods/supplierShop/listMajorCate', data)
}

// 搜款网营销类目树二级
export function selectLastCategoryTreeDetail (data: any) {
  return post('/goods/mall/market/category/selectLastCategoryTree/detail', data)
}

export function goodsProductDownloadImg (img:string) {
  return get(`/goods/product/download/img?img=${img}`, { responseType: 'blob' })
}

// 打开分享链接信息
export function openShareLinkDetailApi (data: any) {
  return post('/goods/productAtlas/openShareLink', data)
}

// 标签列表
export function getTagListApi (data: any) {
  return post('/goods/productAtlas/queryLabel', data)
}

// 查询图册详情
export function getProductAtlasApi (data: any) {
  return req('/goods/productAtlas/detail', data)
}

// 添加心愿单
export function addWishListApi (data: any) {
  return post('/goods/productPhotoAlbum/wishlist/add', data)
}

// 取消心愿单
export function removeWishListApi (data: any) {
  return post('/goods/productPhotoAlbum/wishlist/remove', data)
}

// 分享链接列表
export function queryCustomerShareLinksApi (data: any) {
  return post('/goods/productAtlas/queryCustomerShareLinks', data)
}

// 更新心愿单为已读
export function updateWishlistReadStatusApi (data: any) {
  return post('/goods/productPhotoAlbum/wishlist/canOrder/read', data)
}

// 更新亚马逊商品
export function updateAmazonProductApi (data: any) {
  return post('/api/amazon/product/syncItem', data, {
    headers: {
      Accept: 'application/json, text/plain'
    }
  })
}

// 校验amazon商品
export function checkAmazonGoodsApi (data: any) {
  return req('/api/replenishPlan/checkSku', data)
}
